import React, {useState, useEffect} from 'react';

import { Link, withRouter } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useStoreActions, useStoreState } from "easy-peasy";
import { useHistory } from 'react-router-dom';

function LogIn() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const logIn = useStoreActions(actions => actions.logIn);
  const is_logged_in = useStoreState(state => state.is_logged_in);
  const setIsLoggedIn = useStoreActions(actions => actions.setIsLoggedIn);
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (is_logged_in) {
      history.push("/");
    }
  }, [is_logged_in, history]);

  const handleSubmit = (e) => {
    e.preventDefault();
    logIn({username: username, password: password})
    .then(response => {
      if (response.success) {
        history.push("/");
        setIsLoggedIn(true);
      } else if (response.errors) {
        window.alert(response.errors);
      }
    });
  };

  return (
    <>

      {/*<div className="row pt-5 mt-5">
        <div className="col-12">
          <h1 className="text-center">Log In</h1>
        </div>
      </div>*/}
      <div className="container">
      <div className="row pt-5 mt-4">
        <div className="col text-center">
          <h2 className="h4"><i className="fa-solid fa-right-to-bracket"></i>Sign in to LINKOLN</h2>
        </div>
      </div>
      <Form id="signup" className="row d-flex justify-content-center mx-3" onSubmit={handleSubmit}>
        <div className="col-12 col-md-6 col-lg-4 mx-auto bg-white shadow rounded py-3 m-3 m-sm-0">
          <Form.Group className="col-12 text-start">
            <Form.Label>Email</Form.Label>
            <Form.Control type="input" onChange={(e) => setUsername(e.target.value)} value={username}/>
          </Form.Group>
          <Form.Group className="col-12 text-start">
            <Form.Label>Password</Form.Label>
            <Form.Control type="password" onChange={(e) => setPassword(e.target.value)} value={password}/>
          </Form.Group>
          <div className="col-12">
            <Button type="submit" variant="danger btn-lg w-100 text-uppercase my-4">Sign in</Button>
          </div>
          <div className="col-12">
              <Link to="/forgot_password" className="text-danger">Forgot Password?</Link>
          </div>
        </div>
      </Form>
      </div>
    </>
  );
}

export default withRouter(LogIn);
